import { useEffect, useState, type ReactNode } from "react";

export type PageId =
  | "overview"
  | "errors"
  | "downloads"
  | "installations"
  | "system";

const pages: Array<{ id: PageId; label: string }> = [
  { id: "overview", label: "ОБЗОР" },
  { id: "errors", label: "ОШИБКИ" },
  { id: "downloads", label: "ЗАГРУЗКИ" },
  { id: "installations", label: "КЛИЕНТЫ" },
  { id: "system", label: "СИСТЕМА" }
];

export function Layout({
  page,
  title,
  children,
  authenticationEnabled,
  onNavigate,
  onLogout
}: {
  page: PageId;
  title: string;
  children: ReactNode;
  authenticationEnabled: boolean;
  onNavigate(page: PageId): void;
  onLogout(): void;
}) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1_000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M2 13h4l2.5-7 4 13 3-9 2 3H22" />
            </svg>
          </span>
          <strong>Telemetry service</strong>
        </div>
        <nav>
          {pages.map((item) => (
            <button
              key={item.id}
              className={page === item.id ? "is-active" : ""}
              onClick={() => onNavigate(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
        <div className="sidebar__footer">
          <div className="connection-state">
            <span className="status-dot status-dot--good" />
            API CONNECTED
          </div>
          {authenticationEnabled ? (
            <button className="logout-link" onClick={onLogout}>
              ЗАВЕРШИТЬ СЕССИЮ
            </button>
          ) : (
            <span>LOCAL / NO AUTH</span>
          )}
        </div>
      </aside>
      <main className="main-area">
        <header className="topbar">
          <div>
            <h1>{title}</h1>
          </div>
          <div className="topbar__meta">
            <span>
              {now.toLocaleDateString("ru-RU", {
                timeZone: "Europe/Moscow"
              })}
            </span>
            <span className="mono">
              {now.toLocaleTimeString("ru-RU", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZone: "Europe/Moscow"
              })}{" "}
              MSK
            </span>
          </div>
        </header>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
